import { FC } from 'react';

type GlobeIconProps = {
  width?: number;
  height?: number;
} & React.SVGProps<SVGSVGElement>;

export const GlobeIcon: FC<GlobeIconProps> = ({ width = 24, height = 24, ...rest }) => (
  <svg width={width} height={height} {...rest} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#394B6F" strokeWidth="1.7"/>
    <path d="M8 12C8 18 12 22 12 22C12 22 16 18 16 12C16 6 12 2 12 2C12 2 8 6 8 12Z" stroke="#394B6F" strokeWidth="1.7" strokeLinejoin="round"/>
    <path d="M21 15H3" stroke="#394B6F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M21 9H3" stroke="#394B6F" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
